// Chiamate al backend per "Primo accesso o password dimenticata?"
// Endpoint: backend/src/middleware/password-reset.js
import axios from 'axios';
import config from '../../config/config.json';

const host = config.production.host;

const post = async (path, data) => {
    const response = await axios.post(host + path, data, {
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

export const MIN_PASSWORD_LENGTH = 8;

// Risponde sempre { status: 'ok' }, che l'email esista o no
export const richiediLink = email => post('/password-reset/request', { email });

// true se il link è ancora valido (non lo consuma)
export const verificaLink = async token => (await post('/password-reset/verify', { token })).status === 'ok';

// { status: 'ok' } oppure { status: 'ko', reason: 'invalid_password' | 'invalid_token' | 'update_failed' }
export const confermaPassword = (token, password) => post('/password-reset/confirm', { token, password });
